import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';

import { isOpendoorAppEvoWebView } from 'src/helpers/webview';

import * as matchers from '../../routes/pathMatchers';
import { ReduxState } from '../reducers';

const location = (state: ReduxState) => get(state.router, ['location', 'pathname']) as string;
const queryParams = (state: ReduxState) => get(state.router, ['location', 'search']) as string;

export const getLocation = createSelector(location, (location) => location);
export const getLeadToken = createSelector(location, matchers.matchLeadToken);
export const getCurrentSlug = createSelector(location, matchers.matchSellerFlowSlug);
export const getPageName = createSelector(location, matchers.matchSellerFlowPageName);
export const getTrackingKeywords = createSelector(queryParams, matchers.matchTrackingKeywords);
export const getInApp = createSelector(
  queryParams,
  (queryParams) => matchers.matchInAppQueryParam(queryParams) || isOpendoorAppEvoWebView,
);
export const getChannelQueryParam = createSelector(queryParams, matchers.matchChannelQueryParam);
export const getUtmSourceQueryParam = createSelector(
  queryParams,
  matchers.matchUtmSourceQueryParam,
);
